import type { LearnToFly as LearnToFlyType } from '@/data/types';
import { resolveImagePath } from '@/utils/imageResolver';

interface LearnToFlyProps {
  data: LearnToFlyType;
}

export function LearnToFly({ data }: LearnToFlyProps) {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              {data.title}
            </h2>
            
            <div className="prose prose-lg text-gray-700 mb-8">
              <p>{data.description}</p>
            </div>

            {/* Call-to-Action Links */}
            <ul className="space-y-4">
              {data.links.map((link, index) => (
                <li key={index} className="flex items-center">
                  <div className="flex-shrink-0 w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center mr-4">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <a 
                    href={link.url}
                    className="text-yellow-600 hover:text-yellow-700 font-medium transition-colors duration-200"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Training Aircraft Image & Milestone Card */}
          <div className="lg:col-span-1 space-y-6">
            {/* Training Aircraft Image */}
            {data.image && (
              <div className="relative">
                <img
                  src={resolveImagePath(data.image)}
                  alt="Flight training aircraft"
                  className="w-full h-64 object-cover rounded-lg shadow-lg"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-4 rounded-b-lg">
                  <h3 className="font-semibold text-lg">Ian O'Connor</h3>
                </div>
              </div>
            )}

            {/* Milestone Celebration Text */}
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <p className="text-gray-600 italic mb-4">
                {data.milestoneText}
              </p>
              <a
                href={data.milestoneLink}
                className="inline-block bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 transition-colors duration-200 font-medium"
              >
                {data.milestoneButtonText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}